import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IVideoTutorialCategory } from "../../../Pages/VideoTutorialCategory/IVideoTutorialCategory";

export const ListVideoTutorialCategorySlice = createSlice({
    name: "ListVideoTutorialCategorySlice",
    initialState: {} as IReduxState<IVideoTutorialCategory[]>,
    reducers: {
        listVideoTutorialCategory: (state, action) => {
            state.isLoading = true;
        },
        successlistVideoTutorialCategory: (state, action) => {
            state.data = action.payload;
            state.isLoading = false;
        },
        failurelistVideoTutorialCategory: (state, action) => {
            state.data = action.payload;
            state.isLoading = false;
        },
        clearListVideoTutorialCategory: (state) => {
            state.data = {};
        },
    },
});

export const {
    failurelistVideoTutorialCategory,
    listVideoTutorialCategory,
    successlistVideoTutorialCategory,
    clearListVideoTutorialCategory,
} = ListVideoTutorialCategorySlice.actions;

export default ListVideoTutorialCategorySlice.reducer;
